import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { DICTIONARY } from "./dictionary";

const LANG_KEY = "levelup:lang";

const I18nContext = createContext({ lang: "th", t: (key) => key, tx: (th) => th, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(LANG_KEY) || "th");

  const setLang = useCallback((next) => {
    localStorage.setItem(LANG_KEY, next);
    setLangState(next);
  }, []);

  const value = useMemo(() => {
    const table = DICTIONARY[lang] || DICTIONARY.th;
    return {
      lang,
      setLang,
      isEn: lang === "en",
      // t("action.save") -> "บันทึก" / "Save"
      t: (key, fallback) => table[key] ?? DICTIONARY.th[key] ?? fallback ?? key,
      // tx("ไทย", "English") สำหรับข้อความเฉพาะหน้า
      tx: (th, en) => (lang === "en" && en ? en : th),
      // pick(item) เลือก name/nameEn จาก object ที่มีทั้งสองฟิลด์
      pick: (item, field = "name") => (lang === "en" ? item?.[`${field}En`] || item?.[field] : item?.[field]),
    };
  }, [lang, setLang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
